module.exports = __webpack_public_path__ + "img/dialog_password.6d7ae4c8.svg";